import Splide from '@splidejs/splide';

const MiniSlider = {};

export default MiniSlider

const miniSlider = document.querySelectorAll('.miniSlider__slider');

if (miniSlider) {
    miniSlider.forEach((slider)=>{
        new Splide( slider, {
            type: 	'loop',
            autoplay: "play",
            speed: 2000,
            interval:  5000,
            rewind     : true,
            pagination : true,
            arrows: false,
            perPage: 3.5,
            perMove: 1,
            gap: '40px',
            breakpoints: {
                768: {
                    perPage: 1,
                    pagination: true
                }
            }
            
        } 
            
        ).mount();
    });
}